<template>
	<div class="fragment">
		<span class="operator">
			{{ node.targetIsCommand ? "run command" : "" }}
			{{ node.targetIsEvent ? "fire event" : "" }}
		</span>

		<NodeName v-if="node.isDelay" :node="node" />
		<NodePath v-else :node="node" />

		<template v-if="node.hasArgs">
			<span class="operator">with</span>
			<a class="args" @click="showArgs = !showArgs"
				>arguments
				<v-icon x-small>{{
					showArgs ? "fas fa-angle-down" : "fas fa-angle-up"
				}}</v-icon></a
			>
			<v-simple-table v-if="showArgs" class="fill-width args">
				<tbody>
					<tr v-for="(value, key) in node.args" :key="key">
						<td class="reasonable-width">{{ startCase(key) }}</td>
						<td>{{ startCase(value) }}</td>
					</tr>
				</tbody>
			</v-simple-table>
		</template>
	</div>
</template>

<script>
import { startCase } from "lodash";
import NodeName from "./NodeName.vue";
import NodePath from "./NodePath";

export default {
	components: { NodeName, NodePath },

	props: {
		node: {
			type: Object,
			required: true,
		},
	},

	data: () => ({
		showArgs: false,
	}),

	methods: {
		startCase,
	},
};
</script>

<style lang="scss" scoped>
.reasonable-width {
	width: 14rem;
}
</style>
